export const userDropDown = [
  {
    text: "profile",
    url: "/profile",
  },
  {
    text: "Dashboard",
    url: "/dashboard",
  },
  {
    text: "My jobs",
    url: "/hiring/user/jobs",
  },
  {
    text: "My hiring",
    url: "/hiring/user",
  },
  {
    text: "wallet",
    url: "/wallet",
  },
  {
    text: "Payment history",
    url: "/history",
  },
  {
    text: "Notifications",
    url: "/notifications",
  },
  {
    text: "Messages",
    url: "/messages",
  },
  {
    text: "logout",
    url: "/logout",
  },
];

export const hiringStatus = [
  "pending",
  "in progress",
  "completed",
  "cancelled",
];
